import { createStyles } from "@mantine/core";

export const useStyles = createStyles(() => ({
  control: { cursor: "default", opacity: 1 },
}));
